<template>
	<header id="header">
		<navbar />

		<div id="breadcrumb">
			<h2 class="title">
				{{ breadcrumb.title }}
			</h2>

			<vs-breadcrumb class="breadcrumb" v-if="breadcrumb.title">
				<router-link :to="empresaPk ? {name:  'empresa-prazo-calendario', params: {empresaPk}} : {name: 'empresa-listar'}">
					<li ><home-icon class="icon-home" /></li>
				</router-link>
				<template v-for="breadcrumb in breadcrumb.list">
					<li v-if="breadcrumb" :key="breadcrumb.id">
						<chevrons-right-icon class="chevrons-icon" />
						<span v-if="breadcrumb.active">{{
							breadcrumb.name
						}}</span>
						<div v-else>
							<a
								v-if="breadcrumb.to"
								@click="go(breadcrumb.to)"
								>{{ breadcrumb.name }}</a
							>
							<router-link
								v-else
								:to="{ name: breadcrumb.routeName }"
								>{{ breadcrumb.name }}</router-link
							>
						</div>
					</li>
				</template>
			</vs-breadcrumb>

			<vs-button 
				v-if="breadcrumb.action"
				type="border"
				class="breadcrumb-action-button"
				:disabled="breadcrumb.action.disabled"
				@click="breadcrumb.action.callback"
			>
				{{ breadcrumb.action.label }}
			</vs-button>
		</div>
	</header>
</template>

<script>
import { ChevronsRightIcon, HomeIcon } from "vue-feather-icons";
import { mapState } from "vuex";
import Navbar from "../navbar/Navbar";

export default {
	name: "VxHeader",
	components: {
		ChevronsRightIcon,
		HomeIcon,
		Navbar
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		...mapState(["breadcrumb"])
	},
	methods: {
		go(route) {
			this.$navigate(route);
		},
		resizeItensBreadcrumb() {
			const $breadcrumb = this.$el.querySelector(".breadcrumb");

			if ($breadcrumb) {
				const $list = $breadcrumb.querySelector("ol");
				const $items = $list.querySelectorAll("li");
				const listWidth = $list.offsetWidth;
				let itemsWidth = 0;

				$items.forEach(element => (itemsWidth += element.offsetWidth));

				if (itemsWidth > listWidth) {
					$items.forEach(element => {
						const widthPercentage =
							((element.offsetWidth + 5) * 100) / listWidth;
						element.style.maxWidth = widthPercentage + "%";
					});
				}
			}
		}
	},
	watch: {
		$route() {
			this.resizeItensBreadcrumb();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuesax/_variables.scss";
@import "@/assets/scss/variables.scss";

#header {
	// height: $headerHeight;
	// padding-top: 103px;

	#breadcrumb {
		display: flex;
		align-items: center;
		position: relative;
		width: 100%;
		padding: 0 2.8rem;

		.title {
			max-width: 418px;
			border-right: 1px solid #979797;
			padding-right: 24px;
			margin-right: 19px;
			text-align: left;
		}

		.breadcrumb {
			max-width: calc(100% - 418px);
			min-height: 50px;
			flex: 1;

			ol {
				display: flex;
				align-items: center;
				flex-wrap: nowrap;
				padding: 0px;
				margin-top: 3px;
				width: 100%;
			}
			li {
				display: flex;
				align-items: center;
				padding-top: 1px;
				overflow: hidden;

				a {
					color: $primary;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					cursor: pointer;

					&:hover {
						color: $primary;
					}
				}

				span {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		.breadcrumb-action-button {
			margin-left: 20px;
			font-size: 14px;
			white-space: nowrap;
			height: auto;
			min-height: 36px;
			
			&.vs-button-border {
				border-color: rgba(0, 0, 0, 0.2);
				color: rgba(0, 0, 0, 0.6);
				
				&:hover:not([disabled]) {
					background: rgba(0, 0, 0, 0.05);
					border-color: rgba(0, 0, 0, 0.3);
				}

				&[disabled] {
					opacity: 0.5;
					cursor: not-allowed;
				}
			}
		}

		.chevrons-icon {
			width: 1.1rem;
			margin: 0.15rem 5px;
		}

		.icon-home {
			width: 1.4rem;
			color: $primary;
		}

		@media screen and (max-width: 850px) {
			// flex-direction: column;
			// align-items: flex-start;
			// justify-content: center;
			// height: auto;
			// padding: 10px 0;

			.title {
				margin: 0;
				padding: 0;
				font-size: 22px;
				word-break: break-word;
				border-right: none;
			}

			.breadcrumb {
				display: none;
			}

			.breadcrumb-action-button {
				display: none;
			}
		}
	}
}
</style>
